import { cx } from './cx';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'danger-fill' | 'ghost';
export type ButtonSize = 'l' | 'm' | 's';

/** Button classes, also for links styled as buttons (`<Link className={buttonClass('primary')}>`). */
export function buttonClass(variant: ButtonVariant = 'secondary', size: ButtonSize = 'm', block = false) {
  return cx(styles.button, styles[variant], styles[`size-${size}`], block && styles.block);
}
